import { Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SeasonalSips() {
  return <section data-section-id="227630" id="seasonal-sips" className="bg-background text-foreground relative py-24 md:py-32 px-4 md:px-8 min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_70%)] opacity-10 pointer-events-none" />

      <div className="relative w-full max-w-5xl border-2 border-secondary/20 bg-card/60 backdrop-blur-md p-10 md:p-20 lg:p-28 flex flex-col items-center justify-center text-center z-10 rounded-2xl shadow-lg">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-medium text-foreground mb-12 tracking-tight leading-tight max-w-3xl">
          Craving something fresh and seasonal?
        </h2>

        <div className="relative group mt-4">
          <Link to="/MenuPage" className="relative block">
            <Button size="lg" className="bg-ring text-primary-foreground hover:bg-ring/90 rounded-lg h-16 md:h-20 px-8 md:px-14 text-lg md:text-2xl font-default uppercase tracking-widest font-semibold shadow-xl shadow-ring/20 transition-transform hover:scale-105">
              Check the Menu
              <Zap className="ml-3 w-6 h-6 md:w-8 md:h-8" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}